/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M254.595 77.763c11.62 0 21.05 9.43 21.05 21.05 0 11.62-9.43 21.05-21.05 21.05H42.105v271.596h47.18l57.162-95.284c3.508-5.866 9.655-9.627 16.447-10.16 6.708-.42 13.388 2.274 17.794 7.522l34.69 41.65 68.79-103.171c4.379-6.568 12.097-10.132 19.927-9.234 7.83.898 14.539 6.118 17.29 13.528l58.19 155.15h11.927V256.77c0-11.62 9.43-21.05 21.05-21.05 11.62 0 21.05 9.43 21.05 21.05v233.54c0 11.62-9.43 21.05-21.05 21.05H21.055c-11.62 0-21.05-9.43-21.05-21.05V98.813c0-11.62 9.43-21.05 21.05-21.05h233.54zM100.53 433.56H42.105v35.7h349.397v-35.7H101.913c-.46.015-.92.015-1.382 0zm195.874-144.009l-61.633 92.423c-3.677 5.529-9.74 8.981-16.391 9.346-6.736.28-13.023-2.442-17.289-7.55L167.3 343.242l-28.906 48.217h196.238l-38.227-101.908z" />
      <path d="M122.956 186.035c-8.168 0-14.82 6.651-14.82 14.819 0 8.167 6.652 14.79 14.82 14.79 8.167 0 14.819-6.623 14.819-14.79 0-8.168-6.652-14.82-14.82-14.82m0 63.29c-26.747 0-48.498-21.751-48.498-48.47 0-26.748 21.751-48.499 48.499-48.499 26.747 0 48.498 21.751 48.498 48.499 0 26.719-21.751 48.47-48.498 48.47M412.552 0c11.62 0 21.05 9.43 21.05 21.05v56.707h56.708c11.62 0 21.05 9.43 21.05 21.05 0 11.62-9.43 21.05-21.05 21.05h-56.708v56.708c0 11.62-9.43 21.05-21.05 21.05-11.62 0-21.05-9.43-21.05-21.05v-56.708h-56.708c-11.62 0-21.05-9.43-21.05-21.05 0-11.62 9.43-21.05 21.05-21.05h56.708V21.05c0-11.62 9.43-21.05 21.05-21.05z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconImageUpload = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconImageUpload.defaultProps = {
  theme,
};
IconImageUpload.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconImageUpload.displayName = 'IconImageUpload';
export { IconImageUpload };
